import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=512ebff1"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=512ebff1&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('512ebff1')) {
      api.createRecord('512ebff1', component.options)
    } else {
      api.reload('512ebff1', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=512ebff1", function () {
      api.rerender('512ebff1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/components/layout/layout.vue"
export default component.exports